import type { PropsWithChildren } from 'react';
import styles from './DataList.module.css';

interface DataListProps extends PropsWithChildren {
  className?: string;
}

function DataList({ children, className }: DataListProps) {
  let classes = styles.dataList;
  if (className) {
    classes += ` ${className}`;
  }

  return <dl className={classes}>{children}</dl>;
}

export default DataList;
